import React from 'react';
import {
  ClosureTypeDto,
  GrievanceDetailsContext,
  GrievanceDocumentType,
  GrievanceItem,
  GrievancePhase,
  GrievancePhaseDataApply,
} from '../../../../services/types/Grievance';

const Context = React.createContext<GrievanceDetailsContext>({
  grievanceNumber: '',
  grievance: {} as GrievanceItem,
  grievancePhaseData: {} as GrievancePhaseDataApply,
  phases: [] as GrievancePhase[],
  lookupsClosureTypes: [] as ClosureTypeDto[],
  lookupsDocumentTypes: [] as GrievanceDocumentType[],
  reload: () => {},
  reloadPhases: () => {},
  loading: false,
});

export default Context;
